import { LoyaltyBanner } from 'pages/loyalty/loyalty-banner';

import { useEnableLoyaltyBannerV2 } from './use-enable-loyalty-banner-v2';

export const LoyaltyBannerV2__Experiment = () => {
  const isTreatment = useEnableLoyaltyBannerV2();
  if (isTreatment) {
    return <LoyaltyBanner />;
  }

  return null;
};
